import { Outlet, useParams } from 'react-router-dom';
import { createContext, useContext } from 'react';
import { PlayerContext } from '../../app/PlayerContext';
import { useBeaconFlow } from './useBeaconFlow';
import type { BeaconJoinCoordinator, BeaconJoinState } from './BeaconJoinCoordinator';

interface BeaconContextValue {
  state: BeaconJoinState;
  coordinator: BeaconJoinCoordinator | null;
  isDebugMode: boolean;
}

const BeaconContext = createContext<BeaconContextValue | null>(null);

export function useBeaconContext(): BeaconContextValue {
  const ctx = useContext(BeaconContext);
  if (!ctx) throw new Error('useBeaconContext must be used within BeaconConnectionWrapper');
  return ctx;
}

export const BeaconConnectionWrapper = () => {
  const { shareCode } = useParams<{ shareCode: string }>();

  if (!shareCode) {
    return <div>Invalid beacon link</div>;
  }

  return <BeaconConnectionInner shareCode={shareCode} />;
};

function BeaconConnectionInner({ shareCode }: { shareCode: string }) {
  const { state, coordinator, isDebugMode } = useBeaconFlow(shareCode);

  return (
    <BeaconContext.Provider value={{ state, coordinator, isDebugMode }}>
      <PlayerContext>
        <Outlet />
      </PlayerContext>
    </BeaconContext.Provider>
  );
}
